<app-anagrafica-parte-form
  (parteChange)="onEmitAnagrafica($event)"
  *ngIf="currentForm == form.ANAGRAFICA"></app-anagrafica-parte-form>
<app-step-soggetti-terzi-form-associativa
[parte]="parte"
(altraParteChange)="onEmitAssociativa($event)"
*ngIf="currentForm == form.ASSOCIATIVA"></app-step-soggetti-terzi-form-associativa>
